import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Localization} from '../../../../common/enums/localization';
import {InterventionTeamSummary} from "../../../../buildings/model/Intervention-team-summary";
import {MatMenu} from '@angular/material/menu';
import {InterventionTeamDetailDto} from '../../../intervention-teams/teams/intervention-team-detail.dto';

@Component({
  selector: 'app-action-contextual-menu',
  templateUrl: './action-contextual-menu.component.html',
  styleUrls: ['./action-contextual-menu.component.css']
})
export class ActionContextualMenuComponent {
  @Input()
  public teams: InterventionTeamSummary[];
  @Input()
  public plural = false;
  @ViewChild(MatMenu,  { static: true })
  public menu: MatMenu;
  @Output()
  public assign = new EventEmitter<InterventionTeamDetailDto>();
  @Output()
  public delete = new EventEmitter<void>();
  public Localization = Localization;
}
